import SalaryCard from "./SalaryCard";
import EarnerCard from "./EarnerCard";
import useTranslator from "../../hooks/useTranslator";
import { Badge, Button, Drawer } from "../design";
import "./TotalSalaryModal.css";
import { useContext, useEffect, useState } from "react";
import LandLordContext from "../../context/landlord/LandLordContext";
import AuthContext from "../../context/auth/AuthContext";
const TotalSalaryModal = ({
  isOpen,
  onClose,
  handleUpdateSource,
  effortObj,
  userIncome,
  user,
  gurantorsIncome = [],
  setUpdateSourceObj,
  showReportIcons = true,
  llShowOnly,
  disabledIncomeSourcesFromDb = [],
  profileId,
  loadFullInfo,
  isFromReport,
}) => {
  const { _t } = useTranslator();
  const [activeDropdownId, setActiveDropdownId] = useState(null);
  const [disabledIncomeSources, setDisabledIncomeSources] = useState([]);
  const { user: originalUser } = useContext(AuthContext);
  const { disableIncomeSource } = useContext(LandLordContext);
  const [updateSourceLoading, setUpdateSourceLoading] = useState(false);

  const toggleIncomeSource = (id) => {
    setDisabledIncomeSources((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  useEffect(() => {
    setDisabledIncomeSources(disabledIncomeSourcesFromDb);
  }, []);

  const arraysEqual = (arr1, arr2) => {
    if (arr1.length !== arr2.length) return false;
    return arr1.every((id) => arr2.includes(id));
  };

  const hasChanges = !arraysEqual(
    disabledIncomeSources,
    disabledIncomeSourcesFromDb
  );

  const handleUpdateIncomeSources = async () => {
    const payload = {
      profileOf: "sharedprofile",
      // profileOf: originalUser?.isParentLL ? "agency" : "sharedprofile",
      incomeSources: disabledIncomeSources,
    };
    setUpdateSourceLoading(true);
    disableIncomeSource(profileId, payload)
      .then((res) => {
        loadFullInfo();
      })
      .catch(() => {
        console.log("Failed to income source at in profile");
      })
      .finally(() => {
        setUpdateSourceLoading(false);
      });
  };

  if (!isOpen) return null;

  return (
    <Drawer
      open
      onClose={onClose}
      size="md"
      title={_t("totalSalary")}
      closeLabel={_t("close")}
      footer={
        llShowOnly && hasChanges ? (
          <Button
            size="lg"
            loading={updateSourceLoading}
            onClick={handleUpdateIncomeSources}
          >
            {_t("updatedIncomeSources")}
          </Button>
        ) : null
      }
    >
      <SalaryCard effortObj={effortObj} />
      <div className="totalSalaryDrawer__earnersHead">
        <h3 className="totalSalaryDrawer__earnersTitle">
          {_t("totalEarners")}
        </h3>
        <Badge tone="ink">{(user?.gurantor_id?.length ?? 0) + 1}</Badge>
      </div>
      <div className="totalSalaryDrawer__earners">
        <EarnerCard
          handleUpdateSource={handleUpdateSource}
          userData={userIncome}
          type="tenant"
          setUpdateSourceObj={setUpdateSourceObj}
          allowViewProfile={false}
          showReportIcons={showReportIcons}
          user={user}
          toggleIncomeSource={toggleIncomeSource}
          isEnabled={
            !disabledIncomeSources.includes(userIncome?.all_sources?._id)
          }
          showIncomeSourceSelector={llShowOnly && !isFromReport}
          llShowOnly={llShowOnly}
        />
        {gurantorsIncome.map((data) => (
          <EarnerCard
            key={data?.all_sources?._id}
            handleUpdateSource={handleUpdateSource}
            userData={data}
            type="guarantor"
            setUpdateSourceObj={setUpdateSourceObj}
            onClose={onClose}
            showReportIcons={showReportIcons}
            isDropdown={activeDropdownId === data?.all_sources?._id}
            setIsDropdown={() =>
              setActiveDropdownId(
                activeDropdownId === data?.all_sources?._id
                  ? null
                  : data?.all_sources?._id
              )
            }
            toggleIncomeSource={toggleIncomeSource}
            isEnabled={!disabledIncomeSources.includes(data?.all_sources?._id)}
            showIncomeSourceSelector={llShowOnly && !isFromReport}
            llShowOnly={llShowOnly}
          />
        ))}
      </div>
    </Drawer>
  );
};

export default TotalSalaryModal;
